export const issues = [
	{
		articles: [
			{
				id: 0,
				subSpecialties: [],
				content: "",
				title: "",
				imageUri: "",
				type: "knee",
				rsuiteId: "",
				description: "",
				articleType: "",
				author: "",
				authorImageUri: "",
				authorTitle: "",
				authorDescription: "",
				authorLink: "",
			},
		],
		date: "",
		id: 0,
		volume: 0,
		title: "",
		subSpecialties: [],
		imageUri: "",
		content: "",
		author: "",
		authorImageUri: "",
		authorTitle: "",
		authorDescription: "",
		authorLink: "",
	},
];
